import(/* webpackMode: "eager" */ "/codebuild/output/src653717809/src/app/(auth)/layout.js");
